import { render, staticRenderFns } from "./FeaturesBlocks.vue?vue&type=template&id=f349af32&"
import script from "./FeaturesBlocks.vue?vue&type=script&lang=js&"
export * from "./FeaturesBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports